import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _excluded = ["variant", "children"];

var _templateObject, _templateObject2;

import * as React from 'react';
import { Button as ReakitButton } from 'reakit/Button';
import styled, { css } from '@xstyled/styled-components';

var variant = function variant(_ref) {
  var background = _ref.background,
      backgroundHover = _ref.backgroundHover,
      on = _ref.on;
  return function () {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      background-color: ", ";\n      color: ", ";\n\n      &:hover:not(:disabled) {\n        background-color: ", ";\n        color: ", ";\n      }\n\n      &:active:not(:disabled) {\n        background-color: ", ";\n        color: ", ";\n      }\n    "])), background, on, backgroundHover, on, backgroundHover, on);
  };
};

var InnerButton = styled.buttonBox(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  appearance: none;\n  border-radius: base;\n  transition: base;\n  font-weight: 500;\n  border: 0;\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  font-size: 16;\n  padding: 2 3;\n  text-decoration: none !important;\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: default;\n  }\n\n  &[data-variant='primary'] {\n    ", "\n  }\n\n  &[data-variant='success'] {\n    ", "\n  }\n\n  &[data-variant='danger'] {\n    ", "\n  }\n\n  &[data-variant='neutral'] {\n    ", "\n  }\n"])), variant({
  background: 'primary-600',
  backgroundHover: 'primary-700',
  on: 'white'
}), variant({
  background: 'green-600',
  backgroundHover: 'green-700',
  on: 'white'
}), variant({
  background: 'red-600',
  backgroundHover: 'red-700',
  on: 'white'
}), variant({
  background: 'gray-300',
  backgroundHover: 'gray-400',
  on: 'black'
}));
export var Button = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'primary' : _ref2$variant,
      children = _ref2.children,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(ReakitButton, {
    ref: ref,
    "data-variant": variant
  }, function (buttonProps) {
    return /*#__PURE__*/React.createElement(InnerButton, Object.assign({}, buttonProps, props), children);
  });
});